<template>
  <div class="nuttrema-group-and-sort-virtual">
    <div class="nuttrema-group-and-sort-virtual__item">
      <h4 class="lbl">{{ $t('label.group_by') }}</h4>
      <el-select v-model="groupedBy" @change="handleChangeGroupBy" size="small">
        <el-option v-for="item in grouping.list" :label="$t(item.label)" :value="item.key" :key="item.key"></el-option>
      </el-select>
    </div>
    <div class="nuttrema-group-and-sort-virtual__item">
      <h4 class="lbl">{{ $t('label.sorted_by') }}</h4>
      <el-select v-model="sortedBy" @change="handleChangeSortBy" size="small">
        <el-option v-for="item in sorting.list" :label="$t(item.label)" :value="item.key" :key="item.key"></el-option>
      </el-select>
      <el-button-group>
        <el-button
          type="primary" size="mini"
          :class="{ 'is-active': orderBy === 'asc' }"
          @click="handleChangeOrder('asc')">
            <i class="el-icon-arrow-up"></i>
        </el-button>
        <el-button
          type="primary" size="mini"
          :class="{ 'is-active': orderBy === 'desc' }"
          @click="handleChangeOrder('desc')">
            <i class="el-icon-arrow-down"></i>
        </el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'nuttrema-group-and-sort-virtual',
  props: {
    grouping: {
      type: Object,
      required: true,
      default: null,
    },
    sorting: {
      type: Object,
      required: true,
      default: null,
    },
    orders: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      groupedBy: get(this.grouping, 'selected.key', null),
      sortedBy: get(this.sorting, 'selected.key', null),
      orderBy: get(this.orders, 'selected', null),
    };
  },
  methods: {
    handleChangeGroupBy() {
      console.log('handleChangeGroupBy', this.groupedBy);
      this.$emit('changeGroupBy', this.groupedBy);
    },
    handleChangeSortBy() {
      console.log('handleChangeSortBy', this.sortedBy);
      this.$emit('changeSortBy', this.sortedBy);
    },
    handleChangeOrder(orderBy) {
      console.log('handleChangeOrder', orderBy);
      if (this.orderBy !== orderBy) {
        this.orderBy = orderBy;
        this.$emit('changeOrder', orderBy);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-group-and-sort-virtual {
    display: flex;

    @at-root #{&}__item {
      margin-right: 1em;
      > * {
        display: inline-flex;
      }
      .lbl {
        font-size: 0.95rem;
      }

      /deep/ .el-button-group {
        margin-left: 0.5em;
        .el-button {
          padding: 3px 7px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-group-and-sort-virtual.vue